// extracted by mini-css-extract-plugin
var _1 = "src-components-HomePage-_ModalRedirectDialog__dialogText--Tv6GuM1jgH1qLge8Rc45";
var _2 = "src-components-HomePage-_ModalRedirectDialog__modalRedirectDialog--NKTcXAcBuIG5x1vZA6rq";
export { _1 as "dialogText", _2 as "modalRedirectDialog" }
